module.exports = __webpack_public_path__ + "img/pre-bg.32c399c8.png";